var SystemBundleSlider = {};
SystemBundleSlider.slider = function () {
  var $systemBundleSlider = $('.js-system-bundle-image-slider');
  if ($systemBundleSlider.length === 0) {
    return;
  }

  // Flickity Options
  var options = {
    cellAlign: 'center',
    adaptiveHeight: true,
    wrapAround: true,
    prevNextButtons: true,
    pageDots: false,
    dragThreshold: 3,
    draggable: true,
    selectedAttraction: 0.01,
    friction: 0.15
  };
  $systemBundleSlider.flickity(options);
};
SystemBundleSlider.slider();
window.SystemBundleSlider = SystemBundleSlider;


// WEBPACK FOOTER //
// ./scripts/components/sliders/system-bundle-slider.js